export default {
  name: 'United Kingdom',
  phonePattern: '07123456789',
  postalCodePattern: ['AA1A$ 1AA', 'AA11$ 1AA', 'A1A$ 1AA', 'A11$ 1AA', 'AA1$ 1AA', 'A1$ 1AA'],
  singlePostalCode: '',
  postalCodeRegex: '^(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4})$',
  language: 'en-GB',
  dobFormat: 'DD/MM/YY',
  currency: 'gbp'
}



// WEBPACK FOOTER //
// ./src/locales/countries/GB.js